import { computed } from 'vue';
import useAppSettingsStore from '@/store/modules/appSettings.js';
import useAuthStore from '@/store/modules/auth.js';
import usePageNavigationHook from '@/hooks/usePageNavigation.js';
import { appFlowModeEnum } from '@/constants/appSettings.js';
import { routeIndexGroupNames } from '@/constants/route.js';
import { forgotPasswordStepConfigurationPerRouteName } from '@/constants/forgotPassword.js';

const useForgotPasswordHook = (routeName = '') => {
  const appSettingsStore = useAppSettingsStore();
  const authStore = useAuthStore();

  const { redirectTo, indexRouteName } = usePageNavigationHook();

  const stepConfiguration = computed(() => forgotPasswordStepConfigurationPerRouteName[routeName]?.[appSettingsStore.appFlowMode]);
  const currentStepNumber = computed(() => stepConfiguration.value?.step ?? 1);
  const currentStepPageSubtitle = computed(() => stepConfiguration.value?.pageSubtitle ?? '');
  const isForgotPasswordSupported = computed(() => appSettingsStore.appFlowMode !== appFlowModeEnum.TWO_STEP_SIMPLE_WITHOUT_WEB_REGISTRATION);

  const redirectToIndexStep = () => {
    let routeName = indexRouteName.value;

    switch (appSettingsStore.appFlowMode) {
      case appFlowModeEnum.GENERAL_DEFAULT:
      case appFlowModeEnum.GENERAL_SIMPLE_WITH_WEB_REGISTRATION:
      case appFlowModeEnum.GENERAL_SIMPLE_WITHOUT_WEB_REGISTRATION:
        routeName = authStore.isUserAuthenticated ? 'AuthForgotPasswordAccountVerification' : 'ForgotPasswordAccountVerification';
        break;
      case appFlowModeEnum.TWO_STEP_DEFAULT:
      case appFlowModeEnum.TWO_STEP_SIMPLE_WITH_WEB_REGISTRATION:
        routeName = authStore.isUserAuthenticated ? 'AuthForgotPasswordCodeVerification' : 'ForgotPasswordCodeVerification';
        break;
      case appFlowModeEnum.TWO_STEP_SIMPLE_WITHOUT_WEB_REGISTRATION:
      default:
        break;
    }

    redirectTo(routeName);
  };

  const redirectToNextStep = () => {
    redirectTo(stepConfiguration.value?.nextRouteName || routeIndexGroupNames.VISITOR);
  };

  return {
    stepConfiguration,
    currentStepNumber,
    currentStepPageSubtitle,
    isForgotPasswordSupported,
    redirectToIndexStep,
    redirectToNextStep,
  };
};

export default useForgotPasswordHook;
